import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {LoadingService} from 'src/app/shared/service/loading.service';
import {AdxBookingService} from 'src/app/adx-booking/service/adx-booking.service';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
    selector: 'app-confirmation-dialog-copy-adx-booking',
    templateUrl: './confirmation-dialog-copy-adxbooking.component.html',
    standalone: false
})
export class ConfirmationDialogCopyAdxBookingComponent implements OnInit {
  adxBookingId: number;
  isLoadingSpinner: boolean = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogCopyAdxBookingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adxBookingService: AdxBookingService,
    private _snackBar: MatSnackBar,
    public loader: LoadingService
  ) {
    this.adxBookingId = this.data.adxBookingId;
  }
  ngOnInit(): void {
    this.loader.hide();

  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  okClick(): void {
    this.isLoadingSpinner = true;
    this.adxBookingService.copyAdxBooking(this.adxBookingId)
      .subscribe({
        next: (response) => {
          this.isLoadingSpinner = false;
          this.dialogRef.close(response);
          this._snackBar.open(`Successfully copied booking '${this.data.adxBookingId}'. New booking id: '${response}'.`, 'Dismiss', {
            duration: 0,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['message-position', 'app-notification-success']
          });
        },
        error: (err) => {
          this.isLoadingSpinner = false;
          this.dialogRef.close(false);
          this._snackBar.open(`Error copying booking: ${err.message || 'Unknown error'}`, 'Dismiss', {
            duration: 0,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            panelClass: ['message-position', 'app-notification-error']
          });
        }
      });
  }
}
